import React, { Fragment, useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { TaggingActionCreators } from 'Store/tagging'
import { noSpacingNoSpecialCharactersExceptUnderscore } from 'Forms/Validators'
import {
  Icon,
  Button
} from '@scuf/common'
import {
  MenuContainer,
  MenuTitle,
  ControlsContainer,
  ControlsRow,
  RowNumber,
  EditNameTagContainer
} from './edit-tags.styles'
import {
  TagsContainer
} from '../../tags.styles'

import Select from '../select'
import { ButtonContainer } from 'Components/ScheduleModal/schedule-modal.styles'

const EditTags = ({
  onCloseEdit,
  selectedTags,
  getValues,
  updateValue,
  isAssetDetail,
  updateTags,
  siteId,
  permissions,
  isEditTagValidationShowed,
  setIsEditTagValidationShowed,
  setIsEditTagValidationError,
  isEditTagValidationError,
  t,
  ...rest
}) => {
  useEffect(() => {
    getValues()
  }, [getValues])
  const [isApplyButtonDisabled, setIsApplyButtonDisabled] = useState(true)

 useEffect(() => {
    const hasUndefinedValues = selectedTags?.some(tag => tag?.newValue === undefined);
    setIsApplyButtonDisabled(hasUndefinedValues || isEditTagValidationError);
  }, [selectedTags, isEditTagValidationError]);

  const handleTagValueChange = useCallback((value, tagId) => {
    updateValue(tagId, value);
    const isError = noSpacingNoSpecialCharactersExceptUnderscore(value);
    setIsEditTagValidationError(isError); // Directly updates parent prop method
  }, [updateValue, setIsEditTagValidationError]);
  const dispatch = useDispatch()
  const sendTagsUpdate = (tags) => {
    dispatch(TaggingActionCreators.updateTagsRequest(
      tags.map(a => ({ assetId: a.assets[0], key: a.key, newValue: a.newValue, value: a.value, siteId }))))
  }
  let hasCreateTaggingPermissions = true

  if(permissions['tagging:create']){
    hasCreateTaggingPermissions = true
  }
  else{
    hasCreateTaggingPermissions = false
  }

  return (
    <Fragment>
      <MenuContainer>
        <MenuTitle>
		{t('EditTags')}
        </MenuTitle>
        <Icon
          color='#FFFFFF'
          name='close'
          onClick={onCloseEdit}
          size='small'
        />
      </MenuContainer>
      <TagsContainer>
        <ControlsContainer>
          {selectedTags.map((tag, i) =>
            <ControlsRow key={tag.id}>
              <RowNumber>{i + 1}</RowNumber>
              <EditNameTagContainer>
                <Select
                  disabled={true}
                  label={i ? '\u00A0' : t('Name')}
                  options={[]}
                  placeholder={tag.key}
                />
              </EditNameTagContainer>
                <Select
                  defaultValue={tag.value}
                  label={i ? '\u00A0' : t('Value')}
                  error={isEditTagValidationError ? t('ValidationTagMsg') : ''}
                  onChange={value => {
                    handleTagValueChange(value, tag.id);
                    
                  }}
                  options={tag.values || []}
                  search={hasCreateTaggingPermissions}
                />
            </ControlsRow>
          )}
        </ControlsContainer>
      </TagsContainer>
      <ButtonContainer style={{ paddingTop: '.5rem' }}>
        {isAssetDetail &&
          <Button
            data-testid='applyButton'
            content={t('Apply')}
            onClick={() => sendTagsUpdate(selectedTags)} 
            disabled={isApplyButtonDisabled || isEditTagValidationError}
          />
        }
      </ButtonContainer>
    </Fragment>
  )
}

EditTags.defaultProps = {
  setIsEditTagValidationError: () => {},
  isEditTagValidationError: false,
  selectedTags: [],
  t: label => label
}

EditTags.propTypes = {
  selectedTags: PropTypes.array,
  isEditTagValidationShowed: PropTypes.bool,
  setIsEditTagValidationShowed: PropTypes.func,
  isEditTagValidationError: PropTypes.bool,
  setIsEditTagValidationError: PropTypes.func,
  isAssetDetail: PropTypes.bool,
  t: PropTypes.func
}

export default EditTags
